// Where the frontend looks for its backend.
//
// Production serves the API from the page's own origin under /api. The lab deployment does
// not: the page is served from one port of a lab host while the backend listens on another, so
// it needs an explicit address. That address lives in .env as REACT_APP_DEV_API_URL rather than
// in this file, so it stays configuration instead of source.
//
// The override is honoured in exactly two situations:
//
//   1. a local `yarn start`, where the page is on localhost but the backend is not;
//   2. a page served from the very host the override names.
//
// The second condition matters because production ships the very bundle built for the lab:
// develop:web:build makes the image production:deploy:web:prod retags. Matching on the host is
// what stops production picking up an address meant for the lab.
const devApiUrl = process.env.REACT_APP_DEV_API_URL

const isDevelopmentBuild = process.env.NODE_ENV === 'development'

const overrideAppliesTo = (currentUrl) => {
  if (!devApiUrl) return false
  if (isDevelopmentBuild) return true

  try {
    return new URL(devApiUrl).hostname === currentUrl.hostname
  } catch {
    // A malformed override is configuration noise, not a reason to break the app.
    return false
  }
}

export const getServerUrl = (currentOrigin) => {
  const url = new URL(currentOrigin)
  return overrideAppliesTo(url) ? devApiUrl : `${url.origin}/api`
}

export const serverUrl = getServerUrl(globalThis.location.origin)
